var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-nav-bar',{staticClass:"layout-menu"},[_c('ui-nav-bar-item',{staticClass:"layout-menu__header"},[_vm._v(" Orders ")]),_c('ui-nav-bar-item',{attrs:{"grow":""}},[_c('ui-nav',[_c('ui-nav-item',{attrs:{"active":true},on:{"click":_vm.onYourOrdersClick}},[_vm._v("Your orders")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }